import formatDate from "@/services/formatDate";
import { differenceInDays } from "date-fns";

export function formatPromoPeriod(
  startDate: string | null | undefined,
  endDate: string | null | undefined
) {
  if (!startDate || !endDate) return "";

  const isSameYear = new Date(startDate).getFullYear() === new Date(endDate).getFullYear();
  const startDateFormat = isSameYear ? "LLL dd" : "PP";
  return `${formatDate({ date: startDate, format: startDateFormat })} - ${formatDate({ date: endDate, format: "PP" })}`;
}

// in some cases we will only get the interval but no duration, so we can calculate based on start/end dates
// example: `test-account` promo code
export function getInterval(
  intervalCount: number | undefined | null,
  interval: string | undefined | null,
  startDate: string | undefined | null,
  endDate: string | undefined | null
) {
  if (interval && intervalCount) {
    return { intervalCount, interval };
  }

  if (!startDate || !endDate) return { intervalCount: 0, interval: "day" };
  const days = differenceInDays(new Date(endDate), new Date(startDate));
  switch (interval) {
    case "monthly":
      return { intervalCount: Math.floor(days / 30), interval: "month" };
    case "yearly":
      return { intervalCount: Math.floor(days / 365), interval: "year" };
    case "weekly":
      return { intervalCount: Math.floor(days / 7), interval: "week" };
    default:
      return { intervalCount: days, interval: "day" };
  }
}

export function capitalize(text: string): string {
  return text ? text[0].toUpperCase() + text.slice(1) : "";
}
